import React, { useState, useEffect, useRef } from 'react';

export const SourceQueryItem = ({ sourceText, index, isExpanded, onToggle }) => {
  const [isExpandable, setIsExpandable] = useState(false);
  const descRef = useRef(null);

  useEffect(() => {
    const el = descRef.current;

    if (!el || isExpanded) {
      setIsExpandable(false);
      return;
    }
    
    setIsExpandable(el.scrollHeight > el.clientHeight + 1);
  }, [sourceText, 
     isExpanded]);

  return (
    <div className="sa-conv-source-item">
      <div className="sa-conv-source-title">
        Source {index + 1}
      </div>
      <div
        className={`sa-conv-source-desc${isExpanded ? ' sa-conv-source-desc--expanded' : ''}`}
        ref={descRef}
      >
        {sourceText}
      </div>
      {(isExpandable || isExpanded) && (

        <button onClick={onToggle} className="mi-conv-source-expand-btn">
          {isExpanded ? 'Show Less' : 'Show More'}
        </button>
      )}
    </div>
  );
};

export const CitationItem = ({ citation, index }) => (
  <div className="sa-conv-source-item">
    <div className="sa-conv-source-title">
        Source {index + 1}
    </div>
    <a
      rel="noopener noreferrer"
      target="_blank"
      href={citation.url}
      className="sa-conv-source-desc sa-conv-source-desc--expanded"
    >
      {citation.file_name ||
       citation.url}
    </a>
  </div>
);
